export const imagesConstants = {
    GET_ALL_IMAGES_REQUEST: 'GET_ALL_IMAGES_REQUEST',
    GET_ALL_IMAGES_SUCCESS: 'GET_ALL_IMAGES_SUCCESS',
    GET_ALL_IMAGES_FAILURE: 'GET_ALL_IMAGES_FAILURE',   

    UPDATE_IMAGE_REQUEST: 'UPDATE_IMAGE_REQUEST',
    UPDATE_IMAGE_SUCCESS: 'UPDATE_IMAGE_SUCCESS',
    UPDATE_IMAGE_FAILURE: 'UPDATE_IMAGE_FAILURE',

    DELETE_IMAGE_REQUEST: 'DELETE_IMAGE_REQUEST',
    DELETE_IMAGE_SUCCESS: 'DELETE_IMAGE_SUCCESS',
    DELETE_IMAGE_FAILURE: 'DELETE_IMAGE_FAILURE',

    NEW_IMAGE_FROM_STREAM: 'NEW_IMAGE_FROM_STREAM',

    DOWNLOAD_EVENT_IAMGES_REQUEST: 'DOWNLOAD_EVENT_IAMGES_REQUEST',
    DOWNLOADED_EVENT_IAMGES_CHUNK: 'DOWNLOADED_EVENT_IAMGES_CHUNK',
    DOWNLOAD_EVENT_IMAGES_SUCCESS: 'DOWNLOAD_EVENT_IMAGES_SUCCESS',
    DOWNLOAD_EVENT_IMAGES_FAILURE: 'DOWNLOAD_EVENT_IMAGES_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/images.js